export default "__VITE_ASSET__CcosWrRy__"